import { render, staticRenderFns } from "./MySiswaSpecialIncentive.vue?vue&type=template&id=235b6ba8&"
import script from "./MySiswaSpecialIncentive.vue?vue&type=script&lang=js&"
export * from "./MySiswaSpecialIncentive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports